/**
 * Copyright 2021 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const capitalize = (str: string) => str[0]?.toUpperCase() + str.slice(1);
